"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExposedConstants = void 0;
class ExposedConstants {
}
exports.ExposedConstants = ExposedConstants;
ExposedConstants.UNKNOWN_STRING_VALUE = 'GAL_UNKNOWN_VALUE';
ExposedConstants.UNKNOWN_NUMBER_VALUE = 0;
ExposedConstants.UNKNOWN_ERROR_CODE = 'GAL_UNKNOWN_ERROR';
ExposedConstants.UNKNOWN_ERROR_MESSAGE = 'GAL_UNKNOWN_ERROR_MSG';
ExposedConstants.UNKNOWN_MONETARY_VALUE = 'GAL_UNKNOWN_MONETARY_VALUE';
